<template>
  <div class="WatchVideo">
    <!-- Container -->
    <div class="container">
      <!-- 影片播放器 -->
      <section id="primary" class="section-group">
        <div class="player">
          <video-player
            v-if="getvideoshow"
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="getplayerOptions"
            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @ended="onEndedPause($event)"
          ></video-player>
        </div>
        <div id="video-content" class="card my-3 p-4">
          <div class="video-episode mb-1">{{ videomodel.sgL_ProgramName }}</div>
          <!--所属节目以及集数-->
          <h2 class="video-title mb-1">{{ videomodel.sgL_Mov_VSubject }}</h2>
          <div>
            <div class="video-date">
               {{ $t('Video.WatchVideo.Posted') }} {{ videomodel.sgL_Mov_VAddTimerF }}
            </div>
            <ul class="video-action">
              <!-- <li class="like" title="讚好">
              <a href>
                <i class="far fa-thum                                                                                                                                                                                                                                            bs-up mr-1"></i> 讚好
              </a>
            </li> -->
              <li class="bookmark ml-4" :title="$t('Video.WatchVideo.bookmark')">
                <a
                  href="javascript:void(0)"
                  @click="
                    addfavorite(
                      videomodel.id,
                      videomodel.sgL_MasterSort,
                      2,
                      null
                    )
                  "
                  ><i
                    class="fas fa-bookmark fa-fw"
                    v-if="videomodel.isCollection"
                  ></i
                  ><i v-else class="far fa-bookmark fa-fw"></i
                ></a>
              </li>
              <li class="share ml-4" :title="$t('Video.WatchVideo.share')">
                <a
                  target="_blank"
                  :href="`https://www.facebook.com/sharer/sharer.php?src=sdkpreparse&amp;u=${shareurl}`"
                  style="color: #292c32"
                  @click="addShareCount()"
                >
                  <i class="fa fa-share mr-1"></i> {{ $t('Video.WatchVideo.share') }}</a
                >
                <!-- <ShareNetwork
                  network="facebook"
                  :url="shareurl"
                  title
                  description
                  :quote="videomodel.sgL_Mov_VSubject"
                  :hashtags="videomodel.sgL_Mov_VSubject"
                >
                  <i class="fa fa-share mr-1"></i> 分享
                </ShareNetwork> -->
                <!-- <share></share> -->
              </li>
              <!-- <li class="report ml-4" title="檢舉">
              <a href>
                <i class="fa fa-flag mr-1"></i> 檢舉
              </a>
              </li>-->
            </ul>
          </div>
          <div class="uploader mt-2">
            <a :title="videomodel.sgL_Mem_DisplayName" href="javascript:;">
              <img class="user-logo mr-1" :src="userlogo" />
              {{ videomodel.sgL_Mem_DisplayName }}
            </a>
          </div>
          <div class="clearfix"></div>
          <hr class="divider" />
          <div class="video-description mb-4">
            {{ videomodel.sgL_Mov_VDirections }}
          </div>
          <div class="video-category my-2">
            {{ $t('Video.WatchVideo.type') }}
            <a href>{{ videomodel.sgL_MasterSortName }}</a>
          </div>
          <div
            class="video-tag mt-1"
            v-if="
              videomodel.sgL_Mov_VKeyword != null &&
              videomodel.sgL_Mov_VKeyword != ''
            "
          >
            {{ $t('Video.WatchVideo.keyword') }}:
            <a
              class="tag"
              style="color: #fff"
              v-for="words in videomodel.sgL_Mov_VKeyword.split(',')"
              v-bind:key="words"
              >{{ words }}</a
            >
          </div>

          <!-- <div
            class="fb-comments"
            :data-href="`https://m.soonnet.org/videowatch/15837/video`"
            data-numposts="5"
            data-width
          ></div> -->
          <div>
            <div>
              <hr class="divider" />
              <userCommentsVue
                :props_qryParams="commentsParams"
                ref="comment"
                @submitComment="submitComment"
                @submitComment2="submitComment2"
              ></userCommentsVue>
            </div>
          </div>
        </div>
      </section>
      <!-- ./影片播放器 -->
      <section id="secondary" class="section-group">
        <!-- 廣告 (300x250) -->
        <!-- <a href="https://www.facebook.com/craniumxx">
            <img src="../../assets/images/adv/ad-cranium-300x250.jpg" alt="Advertisement" />s
          </a>-->
        <!-- <ins
            class="adsbygoogle"
            style="display: inline-block; width: 300px; height: 250px"
            data-ad-client="ca-pub-8370308321819212"
            data-ad-slot="7350126089"
          ></ins> -->
        <N2Vue></N2Vue>
        <!-- ./廣告 (300x250) -->
        <div></div>
        <!-- 集數 -->
        <program
          ref="program"
          :aboutprogramList="getaboutprogramList"
          :currentNo="video.sgL_NumberNo"
          :currentId="video.id"
          @changemovie="changemovie"
          v-show="paneshow"
        ></program>
        <!-- 相關影片 @toParent="fromChild" 父子传值-->
        <AboutMovie
          ref="AboutMovie"
          @toParent="fromChild"
          @changemovie="changemovie"
          :aboutdata="video"
        />
        <!-- /.相關影片 -->
      </section>
    </div>
    <!-- /.Container -->
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import AboutMovie from "./AboutMovie";
import program from "./programlist";
import bases from "../../api/httpApi/base";
// import share from "../common/share";
import "../../../node_modules/vue-social-sharing/dist/vue-social-sharing.js";
import userCommentsVue from "../common/userComments.vue";
import N2Vue from "../Ad/N2.vue";
let count = 0;

export default {
  activated: function () {
    this.getCase();
  },
  data() {
    return {
      base: null,
      paneshow: true,
      id: null, //传参接收
      shareurl: location.href, //encodeURIComponent
      itemtype: null, //video/program 根据类型控制集数是否显示
      video: [], //影片信息
      videoshow: false,
      userlogo: "https://api.soonnet.org/Userlogo_Smail.jpg",
      aboutMoiveList: [
        // "http://v.soonnet.org/Video/196572/99565960-2af7-47b2-96b6-6c731c1e49b1/Lok_Basic299368393.MP4",
        // "http://v.soonnet.org/Video/196572/98a1ba1d-300f-4d0b-a501-25b68562cc9c/Lok_Basic4437737142.MP4"
      ],
      aboutprogramList: [],
      playerOptions: {
        autoplay: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true,
        sources: [
          {
            type: "video/mp4",
            src: "",
          },
        ],
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此視頻暫時無法播放，請稍後再試",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true,
        },
      },
      shareConfig: {},
      commentsParams: {
        SGL_PG_Coid: this.$route.params.id,
        SGL_Msg_Type: 5,
      },
    };
  },
  watch: {
    "video.sgL_Mov_VSubject": {
      handler: function (newval, oldval) {
        document.title = newval + " - 尋寶網";
      },
    },
    "video.imageFileP": {
      handler: function (newval, oldval) {
        if (newval != oldval) {
          this.metaSet(newval);
        }
      },
    },
  },
  components: {
    N2Vue,
    program: program,
    AboutMovie: AboutMovie,
    // share: share,
    videoPlayer,
    userCommentsVue,
  },
  //meta动态设置
  // metaInfo() {
  //   return {
  //     title: this.title,
  // meta: [
  //   {
  //     property: "og:title",
  //     name: "ogtitle",
  //     content: this.video.sgL_Mov_VSubject,
  //   },
  //   {
  //     name: "viewport",
  //     content:
  //       "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=yes",
  //   },
  //   { property: "og:image", content: this.video.imageFileP },
  // ],
  //   };
  // },
  created() {
    this.base = bases;
    this.id = this.$route.params.id;
    this.GetVideoDetail(this.id, this.pageViews);
    this.rightBar();
    this.$store.dispatch("updateCurrentIndex", 1);
  },
  mounted() {
  },
  methods: {
    submitComment(data) {
      let params = {
        sgL_PG_CBigsort: this.video.sgL_PG_CMasterSort,
        sgL_PG_Coid: this.commentsParams.SGL_PG_Coid,
        sgL_Msg_Type: this.commentsParams.SGL_Msg_Type,
        sgL_Msg_MContent: data,
        sgL_Msg_SendType: 0,
        SGL_Mem_FinallyReceive_Cid: this.video.sgL_Mem_Cid,
      };
      this.$refs.comment.submit(params);
    },
    submitComment2(
      data,
      sgL_Msg_ReplyMsgid,
      sgL_Mem_FinallyReceive_Cid,
      sgL_Mem_Reply_Cid
    ) {
      let params = {
        sgL_PG_CBigsort: this.video.sgL_PG_CMasterSort,
        sgL_PG_Coid: this.commentsParams.SGL_PG_Coid,
        sgL_Msg_Type: this.commentsParams.SGL_Msg_Type,
        sgL_Msg_MContent: data,
        sgL_Msg_ReplyMsgid: sgL_Msg_ReplyMsgid,
        sgL_Mem_FinallyReceive_Cid: sgL_Mem_FinallyReceive_Cid,
        sgL_Mem_Reply_Cid: sgL_Mem_Reply_Cid,
        sgL_Msg_SendType: 1,
      };
      this.$refs.comment.submit(params);
    },
    pageViews() {
      let params = {};
      // console.log(this.video);
      params[this.video.id] = "10";
      this.$api.VideoApi.pageViews(params);
    },
    addShareCount() {
      let params = {};
      params[this.video.id] = "50";
      this.$api.VideoApi.pageViews(params);
    },
    fromChild(data) {
      this.aboutMoiveList = data;
    },
    //切换影片
    changemovie(payload) {
      this.GetVideoDetail(payload);
    },
    // 播放器的方法
    onPlayerPlay(player) {},
    onPlayerPause(player) {},
    onEndedPause(player) {
      //播放结束后自动播放相关影片或节目
      if (this.itemtype != "video") {
        if (count >= this.aboutprogramList.items.length) {
          count = 0;
          //如果播放列表为0条数据则不播放下一条
          let mid = this.aboutprogramList.items[count].id;
          this.GetVideoDetail(mid).then((s) => {
            this.$router.push({
              name: "WatchVideo",
              params: { id: mid, itemtype: "programselect" },
            });
          });
        } else {
          let mid = this.aboutprogramList.items[count].id;
          this.GetVideoDetail(mid).then((s) => {
            count++;
            this.$router.push({
              name: "WatchVideo",
              params: { id: mid, itemtype: "programselect" },
            });
          });
        }
      } else {
        if (count >= this.aboutMoiveList.length) {
          //如果播放列表为0条数据则不播放下一条
          count = 0;
          let mid = this.aboutprogramList.items[count].id;
          this.GetVideoDetail(mid).then((s) => {
            this.$router.push({
              name: "WatchVideo",
              params: { id: mid, itemtype: "programselect" },
            });
          });
        } else {
          let mid = this.aboutprogramList.items[count].id;
          this.GetVideoDetail(mid).then((s) => {
            this.$router.push({
              name: "WatchVideo",
              params: { id: mid, itemtype: "programselect" },
            });
          });
          count++;
        }
      }
    },
    setMeta(model, type) {
      this.shareurl = escape(
        this.base.url + "/Home/facebookResp?id=" + model.id + "&type=" + type
      );
      // ?ogtitle=" +
      // model.sgL_Mov_VSubject +
      // "&ogimage=" +
      // model.imageFileP +
      // "&ogurl=" +
      // location.href +
      // "&ogdescription=" +
      // model.sgL_Mov_VSubject;
      // var metaogtitle = document.getElementsByName("ogtitle");
      // metaogtitle[0].content = model.sgL_Mov_VSubject;
      // var metaogimage = document.getElementsByName("ogimage");
      // metaogimage[0].content = model.imageFileP;
      // var metaogurl = document.getElementsByName("ogurl");
      // metaogurl[0].content = location.href;
      //  var metaogdescription= document.getElementsByName("ogdescription");
      // metaogdescription[0].content = model.;
    },
    addfavorite(tid, type, Ftype, longid) {
      let params = {
        sgL_DevicesType: 0,
        sgL_MasterSort: type, //类型
        sgL_PG_Coid: tid, //图册、影片、文章、活动的id
        sgL_Fav_FType: Ftype, //图册：0，图片：1，影片：2,文章：4，活动：3
        sgL_Fav_FBelongidc: longid, //图片id
      };
      this.$store.dispatch("addfavorite", params).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: "收藏成功",
          });
          this.GetVideoDetail(this.id);
          // if (Ftype == 0) {
          //   this.getPicturePublish();
          // } else if (Ftype == 2) {
          //   this.getVideoPublish();
          // }
        }
      });
    },
    async GetVideoDetail(id,pageViews) {
      //两种请求方式
      // this.$post('http://172.16.3.47:5006/api/areas/register/registerschedule',param)
      // .then(function(data){
      //   console.log(data);
      // })
      //根据节目id或者影片id进入播放页面、控制集数与相关影片控件的展示
      this.itemtype = this.$route.params.itemtype;
      if (this.itemtype == "video" || this.itemtype == "programselect") {
        var param = {
          Id: id,
        };

        await this.$api.VideoApi.WatchingMovie(param).then((result) => {
          this.video = result.data.result;
          // console.log(this.video);
          if(pageViews){
            pageViews();
          }
          this.setMeta(this.video, this.itemtype);
          this.userlogo = this.video.userLogoSmail;
          this.shareConfig.title = "ces";
          if (this.video.relevanceId != null) {
            //说明它有屬於某個节目
            var param = {
              SGL_Program_Id: this.video.relevanceId,
              Sorting: 1,
              SkipCount: 0,
              MaxResultCount: 100,
            };
            //查询出该节目所有影片
            this.$api.VideoApi.WatchingTv(param).then((result) => {
              if (result.data.result.items.length > 0) {
                this.paneshow = true;
                this.aboutprogramList = result.data.result;
                let str = this.video.sgL_Mov_VSourceExtension.replace(".", "");
                this.playerOptions.sources[0].type = "video/" + str;
                this.playerOptions.sources[0].src = this.video.movieFile;
              } else {
                this.paneshow = false;
              }
            });
          } else {
            this.aboutprogramList = [];
            this.paneshow = false;
          }
          let str = result.data.result.sgL_Mov_VSourceExtension.replace(
            ".",
            ""
          );
          this.playerOptions.sources[0].type = "video/" + str;
          this.playerOptions.sources[0].src = result.data.result.movieFile;
          this.videoshow = true;
        });
      } else {
        this.getmovielistbypid(id, pageViews);
      }
    },
    //根据节目id获取所有影片
    async getmovielistbypid(id, pageViews) {
      //如果是点击节目id进来
      var param = {
        SGL_Program_Id: id,
        Sorting: 1,
        SkipCount: 0,
        MaxResultCount: 100,
      };
      //查询出该节目所有影片
      this.$api.VideoApi.WatchingTv(param).then((result) => {
        this.paneshow = true;
        if (result.data.result.items.length > 0) {
          this.video = result.data.result.items[0];
          if (pageViews) {
            pageViews();
          }
          this.userlogo = this.video.userLogoSmail;
          this.setMeta(this.video, "program");
          this.aboutprogramList = result.data.result;
          let str = this.video.sgL_Mov_VSourceExtension.replace(".", "");
          this.playerOptions.sources[0].type = "video/" + str;
          this.playerOptions.sources[0].src = this.video.movieFile;
          // this.$store.dispatch('getItemProgramList',this.id);
          this.videoshow = true;
        }
      });
    },
    //控制显示集数组件
    rightBar() {
      this.id = this.$route.params.id;
      this.itemtype = this.$route.params.itemtype;
      // if (this.itemtype == "video") {
      //   this.paneshow = false;
      // }
    },
    metaSet(thumbnail) {
      let head = document.getElementsByTagName("head");
      let meta = document.createElement("meta");
      let initMeta = {
        thumbnail: thumbnail,
      };
      document
        .querySelector('meta[name="thumbnail"]')
        .setAttribute("content", thumbnail);
      meta.content = initMeta;
      head[0].appendChild(meta);
    },
  },
  computed: {
    getvideoshow() {
      return this.videoshow;
    },
    player() {
      return this.$refs.videoPlayer.player;
    },
    videomodel() {
      return this.video;
    },
    getplayerOptions() {
      return this.playerOptions;
    },
    getaboutprogramList() {
      return this.aboutprogramList;
    },
  },
};
</script>
 

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
a:hover {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Video/WatchVideo.vue